import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import flatpickr from "flatpickr";
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate' ;
import { ajaxNewReminder, addSMSKeywordRecipient } from '../redux/FeedbackRedux';
import Alert from '../Alert';
import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js';
import FormError from "../FormError";

class PotentialRecipientsSMS extends React.Component {
    constructor(props) {
        super(props);
        this.state = { phone: "", name: "" };

        this.handleAddSMSRecipients = this.handleAddSMSRecipients.bind(this);
      }

    componentDidMount() {
    }

    handleClick(event) {
    }

    handleAddSMSRecipients(user, event) {
        event.preventDefault();
        var phone_map = this.props.state.phone_recipients.map((item, key) => item.phone);
        if (phone_map.includes(user.phone)) {
            this.setState({phone_error:"This phone number is already in the list."});
            return;
        } else {
            var info = {id: user.id, phone: user.phone, name: (user.firstname+" "+user.lastname), email_error: this.props.email_error};
            this.props.dispatch(addSMSKeywordRecipient(user));
            this.setState({phone_error:false});
            jQuery('.modal').modal('hide');
        }
      }

	render () {
                return (
                    <div className="potentialRecipientsList">
                        <p>
                            { __('Users can receive a notification whenever Feedbacks or chat messages with certain keywords are submitted for this business. The message will include the keywords used, along with a link to view the Feedback. Select a user from the list below.') }
                        </p>
                        <FormError error_message={this.state.phone_error}></FormError>
                        <hr/>

                        {this.props.state.potential_recipients.map((item, key) => (
                            <div className="d-inline-block mr-2 mb-2" key={item.uuid}>
                                <a
                                href=""
                                className="btn btn-outline-primary btn-sm"
                                onClick={this.handleAddSMSRecipients.bind(
                                    this,
                                    item
                                )}
                                >
                                <i
                                    className="fas fa-user-plus mr-1"
                                    aria-hidden="true"
                                ></i>{" "}
                                {(item.firstname + " " + item.lastname).trim()}
                                </a>
                            </div>
                        ))}

                    </div>
                 );

	}
}

function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(PotentialRecipientsSMS);
